module.exports = __webpack_public_path__ + "img/idcardf.9bb739c8.png";